const Toggle = ({ onCheck, className, disabled, isChecked }) => {
  return (
    <div className="toggle_wrapper" onClick={(event) => event.stopPropagation()}>
      <label className="toggle">
        <input
          className="checkbox"
          onChange={onCheck}
          checked={isChecked}
          type="checkbox"
          disabled={disabled}
        />
        <div className={`slider ${className}`}></div>
      </label>
    </div>
  )
}

export default Toggle
